var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _g, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 541 390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.543 77.645C387.762 79.6185 391.048 83.1561 392.705 87.509C392.705 87.509 391.97 76.4025 397.113 71.9836C397.113 71.9836 392.456 75.6678 391.473 81.0698C389.244 79.1407 386.475 77.9448 383.543 77.645Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360.671 49.803C360.671 49.803 369.206 56.4366 371.54 62.5517C371.54 62.5517 372.847 55.9937 379.027 54.0274C377.564 54.0057 376.118 54.3407 374.813 55.0033C373.509 55.6659 372.385 56.6362 371.54 57.8304C368.871 54.0583 365.061 51.244 360.671 49.803Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.552 78.6605C351.552 78.6605 358.542 77.5801 361.892 81.8368C361.892 81.8368 359.817 75.4841 361.892 71.1841C361.892 71.1841 359.126 72.9559 360.087 79.3411C360.087 79.3411 357.43 76.5969 351.552 78.6605Z",
    fill: "#263238"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M540.201 313.723H0V313.994H540.201V313.723Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M148.728 321.081H112.945V321.351H148.728V321.081Z",
    fill: "#EBEBEB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M228.926 330.978H184.9V331.248H228.926V330.978Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.865 327.596H56.6777V327.866H111.865V327.596Z",
    fill: "#EBEBEB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M486.073 322.896H385.444V323.166H486.073V322.896Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345.123 327.455H299.498V327.725H345.123V327.455Z",
    fill: "#EBEBEB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M231.984 17.5313H318.481C318.481 17.5313 313.23 9.29863 304.252 13.415C304.252 13.415 302.567 4.77175 296.765 4.62049C295.176 4.50268 293.588 4.84826 292.192 5.61534C290.795 6.38242 289.652 7.53805 288.899 8.9421C288.899 8.9421 282.158 -1.5378 271.862 0.709433C268.996 1.26329 266.374 2.69598 264.361 4.80839C262.347 6.92081 261.042 9.60802 260.625 12.4966C260.625 12.4966 245.251 4.62049 231.984 17.5313Z",
    fill: "#F0F4FE"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8994 137.953H160.332C160.332 137.953 155.092 129.709 146.103 133.826C146.103 133.826 144.417 125.182 138.616 125.031C137.028 124.919 135.441 125.267 134.046 126.033C132.651 126.8 131.507 127.952 130.75 129.353C130.75 129.353 124.019 118.862 113.723 121.109C110.872 121.671 108.266 123.104 106.263 125.209C104.26 127.314 102.96 129.989 102.541 132.864C102.541 132.864 87.1884 125.031 73.8994 137.953Z",
    fill: "#F0F4FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M402.504 79.7193H488.99C488.99 79.7193 483.75 71.4866 474.761 75.603C474.761 75.603 473.087 66.9597 467.274 66.8085C465.687 66.6928 464.101 67.0394 462.707 67.8064C461.313 68.5734 460.171 69.7278 459.42 71.1301C459.42 71.1301 452.678 60.6502 442.382 62.8974C439.516 63.4513 436.895 64.884 434.881 66.9964C432.867 69.1088 431.562 71.796 431.145 74.6846C431.145 74.6846 415.793 66.8085 402.504 79.7193Z",
    fill: "#F0F4FE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M397.17 28.3129C398.286 23.6041 395.373 18.8825 390.664 17.7668C385.956 16.6511 381.234 19.5638 380.118 24.2726C379.003 28.9814 381.915 33.703 386.624 34.8188C391.333 35.9345 396.055 33.0217 397.17 28.3129Z",
    fill: "#FDD400"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6343 79.7193H152.12C152.12 79.7193 146.935 71.4866 137.892 75.603C137.892 75.603 136.206 66.9597 130.404 66.8085C128.818 66.6928 127.231 67.0394 125.837 67.8064C124.443 68.5734 123.301 69.7278 122.55 71.1301C122.55 71.1301 115.808 60.6502 105.512 62.8974C102.647 63.4513 100.025 64.884 98.0112 66.9964C95.9975 69.1088 94.6919 71.796 94.2757 74.6846C94.2757 74.6846 78.9232 66.8085 65.6343 79.7193Z",
    fill: "#F0F4FE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.705 105.93H129V284.899H220.705V105.93Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M204.034 105.93H129V284.899H204.034V105.93Z",
    fill: "#F0F0F0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 105.93H127.023V108.847H221.785V105.93Z",
    fill: "#E0E0E0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 100.085H127.023V103.002H221.785V100.085Z",
    fill: "#E0E0E0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M219.797 103.002H129V105.919H219.797V103.002Z",
    fill: "#F0F0F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 116.464H136.12V130.552H150.208V116.464Z",
    fill: "#E6E6E6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 116.464H137.362V130.552H150.208V116.464Z",
    fill: "#F5F5F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 116.464H157.469V130.552H171.557V116.464Z",
    fill: "#E6E6E6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 116.464H158.711V130.552H171.557V116.464Z",
    fill: "#F5F5F5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 116.464H178.807V130.552H192.895V116.464Z",
    fill: "#E6E6E6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 116.464H180.049V130.552H192.895V116.464Z",
    fill: "#F5F5F5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 137.218H136.12V151.307H150.208V137.218Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 137.218H137.362V151.307H150.208V137.218Z",
    fill: "#F5F5F5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 137.218H157.469V151.307H171.557V137.218Z",
    fill: "#E6E6E6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 137.218H158.711V151.307H171.557V137.218Z",
    fill: "#F5F5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 137.218H178.807V151.307H192.895V137.218Z",
    fill: "#E6E6E6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 137.218H180.049V151.307H192.895V137.218Z",
    fill: "#F5F5F5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 175.216H136.12V189.304H150.208V175.216Z",
    fill: "#E6E6E6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 175.216H137.362V189.304H150.208V175.216Z",
    fill: "#F5F5F5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 175.216H157.469V189.304H171.557V175.216Z",
    fill: "#E6E6E6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 175.216H158.711V189.304H171.557V175.216Z",
    fill: "#F5F5F5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 175.216H178.807V189.304H192.895V175.216Z",
    fill: "#E6E6E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 175.216H180.049V189.304H192.895V175.216Z",
    fill: "#F5F5F5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 195.971H136.12V210.059H150.208V195.971Z",
    fill: "#E6E6E6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 195.971H137.362V210.059H150.208V195.971Z",
    fill: "#F5F5F5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 195.971H157.469V210.059H171.557V195.971Z",
    fill: "#E6E6E6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 195.971H158.711V210.059H171.557V195.971Z",
    fill: "#F5F5F5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 195.971H178.807V210.059H192.895V195.971Z",
    fill: "#E6E6E6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 195.971H180.049V210.059H192.895V195.971Z",
    fill: "#F5F5F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 238.203H136.12V252.292H150.208V238.203Z",
    fill: "#E6E6E6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 238.203H137.362V252.292H150.208V238.203Z",
    fill: "#F5F5F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 238.203H157.469V252.292H171.557V238.203Z",
    fill: "#E6E6E6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 238.203H158.711V252.292H171.557V238.203Z",
    fill: "#F5F5F5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 238.203H178.807V252.292H192.895V238.203Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 238.203H180.049V252.292H192.895V238.203Z",
    fill: "#F5F5F5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 258.958H136.12V273.046H150.208V258.958Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M150.208 258.958H137.362V273.046H150.208V258.958Z",
    fill: "#F5F5F5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 258.958H157.469V273.046H171.557V258.958Z",
    fill: "#E6E6E6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.557 258.958H158.711V273.046H171.557V258.958Z",
    fill: "#F5F5F5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 258.958H178.807V273.046H192.895V258.958Z",
    fill: "#E6E6E6"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M192.895 258.958H180.049V273.046H192.895V258.958Z",
    fill: "#F5F5F5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M220.705 161.214H129V162.521H220.705V161.214Z",
    fill: "#E0E0E0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M220.705 226.179H129V227.486H220.705V226.179Z",
    fill: "#E0E0E0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M113.518 159.518H50.0874V313.864H113.518V159.518Z",
    fill: "#E0E0E0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4535 159.518H50.0874V313.864H95.4535V159.518Z",
    fill: "#F0F0F0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 172.202H54.7549V180.402H71.6416V172.202Z",
    fill: "#E6E6E6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 172.202H55.8784V180.402H71.6415V172.202Z",
    fill: "#F5F5F5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 172.202H74.2886V180.402H91.1752V172.202Z",
    fill: "#E6E6E6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 172.202H75.4121V180.402H91.1644V172.202Z",
    fill: "#F5F5F5"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 187.63H54.7549V195.83H71.6416V187.63Z",
    fill: "#E6E6E6"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 187.63H55.8784V195.83H71.6415V187.63Z",
    fill: "#F5F5F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 187.63H74.2886V195.83H91.1752V187.63Z",
    fill: "#E6E6E6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 187.63H75.4121V195.83H91.1644V187.63Z",
    fill: "#F5F5F5"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 207.347H54.7549V215.547H71.6416V207.347Z",
    fill: "#E6E6E6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 207.347H55.8784V215.547H71.6415V207.347Z",
    fill: "#F5F5F5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 207.347H74.2886V215.547H91.1752V207.347Z",
    fill: "#E6E6E6"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 207.347H75.4121V215.547H91.1644V207.347Z",
    fill: "#F5F5F5"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 218.67H54.7549V226.87H71.6416V218.67Z",
    fill: "#E6E6E6"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 218.67H55.8784V226.87H71.6415V218.67Z",
    fill: "#F5F5F5"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 218.67H74.2886V226.87H91.1752V218.67Z",
    fill: "#E6E6E6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 218.67H75.4121V226.87H91.1644V218.67Z",
    fill: "#F5F5F5"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 237.285H54.7549V245.485H71.6416V237.285Z",
    fill: "#E6E6E6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 237.285H55.8784V245.485H71.6415V237.285Z",
    fill: "#F5F5F5"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 237.285H74.2886V245.485H91.1752V237.285Z",
    fill: "#E6E6E6"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 237.285H75.4121V245.485H91.1644V237.285Z",
    fill: "#F5F5F5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 248.608H54.7549V256.808H71.6416V248.608Z",
    fill: "#E6E6E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 248.608H55.8784V256.808H71.6415V248.608Z",
    fill: "#F5F5F5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 248.608H74.2886V256.808H91.1752V248.608Z",
    fill: "#E6E6E6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 248.608H75.4121V256.808H91.1644V248.608Z",
    fill: "#F5F5F5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 268.865H54.7549V277.065H71.6416V268.865Z",
    fill: "#E6E6E6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 268.865H55.8784V277.065H71.6415V268.865Z",
    fill: "#F5F5F5"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 268.865H74.2886V277.065H91.1752V268.865Z",
    fill: "#E6E6E6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 268.865H75.4121V277.065H91.1644V268.865Z",
    fill: "#F5F5F5"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6416 283.818H54.7549V292.018H71.6416V283.818Z",
    fill: "#E6E6E6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6415 283.818H55.8784V292.018H71.6415V283.818Z",
    fill: "#F5F5F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1752 283.818H74.2886V292.018H91.1752V283.818Z",
    fill: "#E6E6E6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1644 283.818H75.4121V292.018H91.1644V283.818Z",
    fill: "#F5F5F5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M113.518 200.875H50.0874V202.291H113.518V200.875Z",
    fill: "black"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M113.518 231.365H50.0874V232.78H113.518V231.365Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M113.518 262.124H50.0874V263.528H113.518V262.124Z",
    fill: "black"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M113.507 154.948H47.0947V159.874H113.507V154.948Z",
    fill: "#E0E0E0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M113.518 154.948H98.3384V159.874H113.518V154.948Z",
    fill: "black"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 79.125H258.605V272.701H333.088V79.125Z",
    fill: "#E6E6E6"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M305.516 79.125H231.033V272.701H305.516V79.125Z",
    fill: "#F0F0F0"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 92.2627H237.537V102.127H299.023V92.2627Z",
    fill: "#E6E6E6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 92.2627H239.914V102.127H299.012V92.2627Z",
    fill: "#F5F5F5"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 108.869H237.537V118.733H299.023V108.869Z",
    fill: "#E6E6E6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 108.869H239.914V118.733H299.012V108.869Z",
    fill: "#F5F5F5"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 126.112H237.537V135.976H299.023V126.112Z",
    fill: "#E6E6E6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 126.112H239.914V135.976H299.012V126.112Z",
    fill: "#F5F5F5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 143.366H237.537V153.23H299.023V143.366Z",
    fill: "#E6E6E6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 143.366H239.914V153.23H299.012V143.366Z",
    fill: "#F5F5F5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 160.609H237.537V170.473H299.023V160.609Z",
    fill: "#E6E6E6"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 160.609H239.914V170.473H299.012V160.609Z",
    fill: "#F5F5F5"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 177.863H237.537V187.727H299.023V177.863Z",
    fill: "#E6E6E6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 177.863H239.914V187.727H299.012V177.863Z",
    fill: "#F5F5F5"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 196.867H237.537V206.731H299.023V196.867Z",
    fill: "#E6E6E6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 196.867H239.914V206.731H299.012V196.867Z",
    fill: "#F5F5F5"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 215.882H237.537V225.746H299.023V215.882Z",
    fill: "#E6E6E6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 215.882H239.914V225.746H299.012V215.882Z",
    fill: "#F5F5F5"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 234.897H237.537V244.762H299.023V234.897Z",
    fill: "#E6E6E6"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 234.897H239.914V244.762H299.012V234.897Z",
    fill: "#F5F5F5"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M299.023 253.902H237.537V263.766H299.023V253.902Z",
    fill: "#E6E6E6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M299.012 253.902H239.914V263.766H299.012V253.902Z",
    fill: "#F5F5F5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M335.022 77.1804H228.926V81.9018H335.022V77.1804Z",
    fill: "#E0E0E0"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M335.022 68.656H228.926V73.3774H335.022V68.656Z",
    fill: "#E0E0E0"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M331.5 72.4482H231.033V77.1696H331.5V72.4482Z",
    fill: "#F0F0F0"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 92.2627H312.333V102.127H333.088V92.2627Z",
    fill: "#E0E0E0"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 108.49H312.333V118.355H333.088V108.49Z",
    fill: "#E0E0E0"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 124.729H312.333V134.593H333.088V124.729Z",
    fill: "#E0E0E0"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 143.355H312.333V153.219H333.088V143.355Z",
    fill: "#E0E0E0"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 160.609H312.333V170.473H333.088V160.609Z",
    fill: "#E0E0E0"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 177.863H312.333V187.727H333.088V177.863Z",
    fill: "#E0E0E0"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 196.867H312.333V206.731H333.088V196.867Z",
    fill: "#E0E0E0"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 215.882H312.333V225.746H333.088V215.882Z",
    fill: "#E0E0E0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 234.887H312.333V244.751H333.088V234.887Z",
    fill: "#E0E0E0"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M333.088 253.902H312.333V263.766H333.088V253.902Z",
    fill: "#E0E0E0"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 227.605H495.699V236.95H501.674V227.605Z",
    fill: "#E0E0E0"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 242.903H495.699V252.249H501.674V242.903Z",
    fill: "#E0E0E0"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 257.759H495.699V267.104H501.674V257.759Z",
    fill: "#E0E0E0"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 273.479H495.699V282.824H501.674V273.479Z",
    fill: "#E0E0E0"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 288.766H495.699V298.112H501.674V288.766Z",
    fill: "#E0E0E0"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M501.674 218.216H438.827V313.799H501.674V218.216Z",
    fill: "#E6E6E6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M491.064 218.216H438.838V313.799H491.064V218.216Z",
    fill: "#F0F0F0"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M486.008 227.605H443.538V236.95H486.008V227.605Z",
    fill: "#EBEBEB"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M486.008 242.903H443.538V252.249H486.008V242.903Z",
    fill: "#EBEBEB"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M486.008 258.191H443.538V267.536H486.008V258.191Z",
    fill: "#EBEBEB"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M486.008 273.479H443.538V282.824H486.008V273.479Z",
    fill: "#EBEBEB"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M486.008 288.766H443.538V298.112H486.008V288.766Z",
    fill: "#EBEBEB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M485.997 227.605H445.093V236.95H485.997V227.605Z",
    fill: "#F5F5F5"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M485.997 242.903H445.093V252.249H485.997V242.903Z",
    fill: "#F5F5F5"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M485.997 258.191H445.093V267.536H485.997V258.191Z",
    fill: "#F5F5F5"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M485.997 273.479H445.093V282.824H485.997V273.479Z",
    fill: "#F5F5F5"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M485.997 288.766H445.093V298.112H485.997V288.766Z",
    fill: "#F5F5F5"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M235.852 137.748H128.859V346.546H235.852V137.748Z",
    fill: "#407BFF"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M216.404 137.748H128.859V346.546H216.404V137.748Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M237.116 137.748H126.558V141.151H237.116V137.748Z",
    fill: "#407BFF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M237.116 130.93H126.558V134.344H237.116V130.93Z",
    fill: "#407BFF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M234.793 134.344H128.859V137.748H234.793V134.344Z",
    fill: "#F0F0F0"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 150.043H137.167V166.486H153.611V150.043Z",
    fill: "#407BFF"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 150.043H138.615V166.486H153.611V150.043Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 150.043H162.071V166.486H178.515V150.043Z",
    fill: "#407BFF"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 150.043H163.519V166.486H178.515V150.043Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 150.043H186.963V166.486H203.407V150.043Z",
    fill: "#407BFF"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 150.043H188.411V166.486H203.407V150.043Z",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 174.255H137.167V190.698H153.611V174.255Z",
    fill: "#407BFF"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 174.255H138.615V190.698H153.611V174.255Z",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 174.255H162.071V190.698H178.515V174.255Z",
    fill: "#407BFF"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 174.255H163.519V190.698H178.515V174.255Z",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 174.255H186.963V190.698H203.407V174.255Z",
    fill: "#407BFF"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 174.255H188.411V190.698H203.407V174.255Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 218.583H137.167V235.027H153.611V218.583Z",
    fill: "#407BFF"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 218.583H138.615V235.027H153.611V218.583Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 218.583H162.071V235.027H178.515V218.583Z",
    fill: "#407BFF"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 218.583H163.519V235.027H178.515V218.583Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 218.583H186.963V235.027H203.407V218.583Z",
    fill: "#407BFF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 218.583H188.411V235.027H203.407V218.583Z",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 242.795H137.167V259.239H153.611V242.795Z",
    fill: "#407BFF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 242.795H138.615V259.239H153.611V242.795Z",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 242.795H162.071V259.239H178.515V242.795Z",
    fill: "#407BFF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 242.795H163.519V259.239H178.515V242.795Z",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 242.795H186.963V259.239H203.407V242.795Z",
    fill: "#407BFF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 242.795H188.411V259.239H203.407V242.795Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 292.072H137.167V308.516H153.611V292.072Z",
    fill: "#407BFF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 292.072H138.615V308.516H153.611V292.072Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 292.072H162.071V308.516H178.515V292.072Z",
    fill: "#407BFF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 292.072H163.519V308.516H178.515V292.072Z",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 292.072H186.963V308.516H203.407V292.072Z",
    fill: "#407BFF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 292.072H188.411V308.516H203.407V292.072Z",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M153.611 316.284H137.167V332.728H153.611V316.284Z",
    fill: "#407BFF"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.611 316.284H138.615V332.728H153.611V316.284Z",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M178.515 316.284H162.071V332.728H178.515V316.284Z",
    fill: "#407BFF"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.515 316.284H163.519V332.728H178.515V316.284Z",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M203.407 316.284H186.963V332.728H203.407V316.284Z",
    fill: "#407BFF"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M203.407 316.284H188.411V332.728H203.407V316.284Z",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.852 202.259H128.859V203.782H235.852V202.259Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M235.852 278.038H128.859V279.561H235.852V278.038Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M383.164 166.486H309.167V346.546H383.164V166.486Z",
    fill: "#407BFF"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M365.456 166.486H309.167V346.546H365.456V166.486Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 181.277H314.624V190.839H334.319V181.277Z",
    fill: "#407BFF"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 181.277H315.931V190.839H334.32V181.277Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 181.277H337.409V190.839H357.105V181.277Z",
    fill: "#407BFF"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 181.277H338.717V190.839H357.105V181.277Z",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 199.277H314.624V208.838H334.319V199.277Z",
    fill: "#407BFF"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 199.277H315.931V208.838H334.32V199.277Z",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 199.277H337.409V208.838H357.105V199.277Z",
    fill: "#407BFF"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 199.277H338.717V208.838H357.105V199.277Z",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 222.278H314.624V231.84H334.319V222.278Z",
    fill: "#407BFF"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 222.278H315.931V231.84H334.32V222.278Z",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 222.278H337.409V231.84H357.105V222.278Z",
    fill: "#407BFF"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 222.278H338.717V231.84H357.105V222.278Z",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 235.492H314.624V245.053H334.319V235.492Z",
    fill: "#407BFF"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 235.492H315.931V245.053H334.32V235.492Z",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 235.492H337.409V245.053H357.105V235.492Z",
    fill: "#407BFF"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 235.492H338.717V245.053H357.105V235.492Z",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 257.208H314.624V266.769H334.319V257.208Z",
    fill: "#407BFF"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 257.208H315.931V266.769H334.32V257.208Z",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 257.208H337.409V266.769H357.105V257.208Z",
    fill: "#407BFF"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 257.208H338.717V266.769H357.105V257.208Z",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 270.421H314.624V279.983H334.319V270.421Z",
    fill: "#407BFF"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 270.421H315.931V279.983H334.32V270.421Z",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 270.421H337.409V279.983H357.105V270.421Z",
    fill: "#407BFF"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 270.421H338.717V279.983H357.105V270.421Z",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 294.05H314.624V303.611H334.319V294.05Z",
    fill: "#407BFF"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 294.05H315.931V303.611H334.32V294.05Z",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 294.05H337.409V303.611H357.105V294.05Z",
    fill: "#407BFF"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 294.05H338.717V303.611H357.105V294.05Z",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M334.319 311.509H314.624V321.07H334.319V311.509Z",
    fill: "#407BFF"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M334.32 311.509H315.931V321.07H334.32V311.509Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M357.105 311.509H337.409V321.07H357.105V311.509Z",
    fill: "#407BFF"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M357.105 311.509H338.717V321.07H357.105V311.509Z",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M383.175 161.16H305.688V166.908H383.175V161.16Z",
    fill: "#407BFF"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.175 161.16H365.467V166.908H383.175V161.16Z",
    fill: "black"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 245.993H302.199V256.894H309.168V245.993Z",
    fill: "#E0E0E0"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 263.831H302.199V274.732H309.168V263.831Z",
    fill: "#E0E0E0"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 281.171H302.199V292.072H309.168V281.171Z",
    fill: "#E0E0E0"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 299.506H302.199V310.407H309.168V299.506Z",
    fill: "#E0E0E0"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 317.343H302.199V328.244H309.168V317.343Z",
    fill: "#E0E0E0"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M309.168 235.038H235.852V346.546H309.168V235.038Z",
    fill: "#407BFF"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M296.786 235.027H235.852V346.546H296.786V235.027Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M290.876 245.993H241.329V256.894H290.876V245.993Z",
    fill: "#407BFF"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M290.876 263.831H241.329V274.732H290.876V263.831Z",
    fill: "#407BFF"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M290.876 281.668H241.329V292.569H290.876V281.668Z",
    fill: "#407BFF"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M290.876 299.506H241.329V310.407H290.876V299.506Z",
    fill: "#407BFF"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M290.876 317.343H241.329V328.244H290.876V317.343Z",
    fill: "#407BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.876 245.993H243.155V256.894H290.876V245.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.876 263.831H243.155V274.732H290.876V263.831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.876 281.668H243.155V292.569H290.876V281.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.876 299.505H243.155V310.407H290.876V299.505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M290.876 317.343H243.155V328.244H290.876V317.343Z",
    fill: "white"
  }))), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8977 269.287H35.707V346.546H114.209V269.287V235.027L84.8977 269.287Z",
    fill: "#407BFF"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M128.859 235.027H114.209V346.546H128.859V235.027Z",
    fill: "#407BFF"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M128.859 235.027H114.209V346.546H128.859V235.027Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M235.852 141.151H216.394V346.546H235.852V141.151Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M309.167 235.027H296.786V346.546H309.167V235.027Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M383.175 166.908H365.467V346.546H383.175V166.908Z",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 136.041H390.749V147.547H393.536V136.041Z",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 155.402H390.749V166.908H393.536V155.402Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 175.53H390.749V187.036H393.536V175.53Z",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 195.657H390.749V207.163H393.536V195.657Z",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 215.774H390.749V227.281H393.536V215.774Z",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 235.902H390.749V247.409H393.536V235.902Z",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 258.083H390.749V269.589H393.536V258.083Z",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 280.264H390.749V291.77H393.536V280.264Z",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 302.433H390.749V313.94H393.536V302.433Z",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M393.536 324.614H390.749V336.12H393.536V324.614Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M502.236 120.71H415.339V346.546H502.236V120.71Z",
    fill: "#407BFF"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M470.061 120.71H383.165V346.546H470.061V120.71Z",
    fill: "#407BFF"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M502.236 123.951H470.072V346.546H502.236V123.951Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 136.041H478.023V147.547H502.235V136.041Z",
    fill: "#407BFF"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 154.969H478.023V166.476H502.235V154.969Z",
    fill: "#407BFF"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 173.909H478.023V185.415H502.235V173.909Z",
    fill: "#407BFF"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 195.646H478.023V207.153H502.235V195.646Z",
    fill: "#407BFF"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 215.774H478.023V227.281H502.235V215.774Z",
    fill: "#407BFF"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 235.902H478.023V247.409H502.235V235.902Z",
    fill: "#407BFF"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 258.072H478.023V269.579H502.235V258.072Z",
    fill: "#407BFF"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 280.253H478.023V291.759H502.235V280.253Z",
    fill: "#407BFF"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 302.433H478.023V313.94H502.235V302.433Z",
    fill: "#407BFF"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M502.235 324.614H478.023V336.12H502.235V324.614Z",
    fill: "#407BFF"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 136.041H478.023V147.547H502.235V136.041Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 154.969H478.023V166.476H502.235V154.969Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 173.909H478.023V185.415H502.235V173.909Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 195.646H478.023V207.153H502.235V195.646Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 215.774H478.023V227.281H502.235V215.774Z",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 235.902H478.023V247.409H502.235V235.902Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 258.072H478.023V269.579H502.235V258.072Z",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 280.253H478.023V291.759H502.235V280.253Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 302.433H478.023V313.94H502.235V302.433Z",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M502.235 324.614H478.023V336.12H502.235V324.614Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M470.061 120.71H383.165V346.546H470.061V120.71Z",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 136.041H390.749V147.547H462.488V136.041Z",
    fill: "#407BFF"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 136.041H393.536V147.547H462.487V136.041Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 155.402H390.749V166.908H462.488V155.402Z",
    fill: "#407BFF"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 155.402H393.536V166.908H462.487V155.402Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 175.53H390.749V187.036H462.488V175.53Z",
    fill: "#407BFF"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 175.53H393.536V187.036H462.487V175.53Z",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 195.657H390.749V207.163H462.488V195.657Z",
    fill: "#407BFF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 195.657H393.536V207.163H462.487V195.657Z",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 215.774H390.749V227.281H462.488V215.774Z",
    fill: "#407BFF"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 215.774H393.536V227.281H462.487V215.774Z",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 235.902H390.749V247.409H462.488V235.902Z",
    fill: "#407BFF"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 235.902H393.536V247.409H462.487V235.902Z",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 258.083H390.749V269.589H462.488V258.083Z",
    fill: "#407BFF"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 258.083H393.536V269.589H462.487V258.083Z",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 280.264H390.749V291.77H462.488V280.264Z",
    fill: "#407BFF"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 280.264H393.536V291.77H462.487V280.264Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 302.433H390.749V313.94H462.488V302.433Z",
    fill: "#407BFF"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 302.433H393.536V313.94H462.487V302.433Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M462.488 324.614H390.749V336.12H462.488V324.614Z",
    fill: "#407BFF"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M462.487 324.614H393.536V336.12H462.487V324.614Z",
    fill: "white"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M500.378 114H470.072V118.43H500.378V114Z",
    fill: "#407BFF"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M500.377 112.92H383.165V118.43H500.377V112.92Z",
    fill: "#F0F0F0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M504.494 118.441H380.712V123.951H504.494V118.441Z",
    fill: "#407BFF"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M504.494 108.49H380.712V114.001H504.494V108.49Z",
    fill: "#407BFF"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M504.494 118.441H380.712V123.951H504.494V118.441Z",
    fill: "black"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M504.494 108.49H380.712V114.001H504.494V108.49Z",
    fill: "black"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.164 214.467H309.167V216.109H383.164V214.467Z",
    fill: "white"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.164 250.045H309.167V251.687H383.164V250.045Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M383.164 285.925H309.167V287.567H383.164V285.925Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.105 137.748H216.394V141.151H237.105V137.748Z",
    fill: "black"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M237.105 130.93H216.394V134.334H237.105V130.93Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M504.494 118.441H470.072V123.951H504.494V118.441Z",
    fill: "black"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M504.494 108.49H470.072V114.001H504.494V108.49Z",
    fill: "black"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M84.8977 269.287H35.707V346.546H114.209V269.287V235.027L84.8977 269.287Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5058 284.953H42.8267V296.632H54.5058V284.953Z",
    fill: "#407BFF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2749 284.953H66.5957V296.632H78.2749V284.953Z",
    fill: "#407BFF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M102.044 284.953H90.3647V296.632H102.044V284.953Z",
    fill: "#407BFF"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5058 304.605H42.8267V316.284H54.5058V304.605Z",
    fill: "#407BFF"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2749 304.605H66.5957V316.284H78.2749V304.605Z",
    fill: "#407BFF"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M102.044 304.605H90.3647V316.284H102.044V304.605Z",
    fill: "#407BFF"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5058 324.258H42.8267V335.937H54.5058V324.258Z",
    fill: "#407BFF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2749 324.258H66.5957V335.937H78.2749V324.258Z",
    fill: "#407BFF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M102.044 324.258H90.3647V335.937H102.044V324.258Z",
    fill: "#407BFF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.8027 284.953H44.1235V296.632H55.8027V284.953Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.5605 284.953H67.8813V296.632H79.5605V284.953Z",
    fill: "white"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.33 284.953H91.6504V296.632H103.33V284.953Z",
    fill: "white"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.8027 304.605H44.1235V316.284H55.8027V304.605Z",
    fill: "white"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.5605 304.605H67.8813V316.284H79.5605V304.605Z",
    fill: "white"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.33 304.605H91.6504V316.284H103.33V304.605Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M55.8027 324.258H44.1235V335.937H55.8027V324.258Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.5605 324.258H67.8813V335.937H79.5605V324.258Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M103.33 324.258H91.6504V335.937H103.33V324.258Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M263.726 355.503L256.963 389.816H279.662L277.361 355.503H263.726Z",
    fill: "#FDD400"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M284.945 355.503L294.669 389.816H309.881L297.413 355.503H284.945Z",
    fill: "#FDD400"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M305.97 355.503L325.979 389.816H343.244L317.239 355.503H305.97Z",
    fill: "#FDD400"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M326.271 355.503L359.429 389.816H380.075L338.642 355.503H326.271Z",
    fill: "#FDD400"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M255.256 355.503L245.532 389.816H230.32L242.788 355.503H255.256Z",
    fill: "#FDD400"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M234.231 355.503L214.222 389.816H196.958L222.963 355.503H234.231Z",
    fill: "#FDD400"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M213.93 355.503L180.773 389.816H160.126L201.56 355.503H213.93Z",
    fill: "#FDD400"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M108.753 342.581C112.729 342.44 116.632 341.472 120.213 339.739C123.793 338.005 126.973 335.544 129.549 332.512C132.125 329.48 134.041 325.945 135.174 322.132C136.308 318.318 136.633 314.31 136.131 310.364C135.418 304.735 133.062 299.473 131.399 294.05C128.255 283.797 127.25 272.226 120.033 264.285C117.805 261.842 115.093 259.891 112.069 258.557C109.045 257.222 105.776 256.532 102.471 256.532C99.1654 256.532 95.8964 257.222 92.8725 258.557C89.8486 259.891 87.1363 261.842 84.9089 264.285C80.2308 269.416 78.016 276.353 77.0544 283.235C76.0928 290.117 76.2225 297.086 75.6283 303.968C75.0881 309.705 73.9969 315.431 74.2345 321.189C74.4722 326.948 76.2009 332.944 80.4253 336.866C82.5819 338.704 84.9904 340.225 87.5775 341.382C90.0682 342.769 92.7688 343.74 95.5725 344.256C96.9775 344.505 98.4205 344.435 99.7949 344.052C101.169 343.668 102.44 342.981 103.513 342.041C105.224 342.475 106.99 342.657 108.753 342.581Z",
    fill: "#407BFF"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M108.753 342.581C112.729 342.44 116.632 341.472 120.213 339.739C123.793 338.005 126.973 335.544 129.549 332.512C132.125 329.48 134.041 325.945 135.174 322.132C136.308 318.318 136.633 314.31 136.131 310.364C135.418 304.735 133.062 299.473 131.399 294.05C128.255 283.797 127.25 272.226 120.033 264.285C117.805 261.842 115.093 259.891 112.069 258.557C109.045 257.222 105.776 256.532 102.471 256.532C99.1654 256.532 95.8964 257.222 92.8725 258.557C89.8486 259.891 87.1363 261.842 84.9089 264.285C80.2308 269.416 78.016 276.353 77.0544 283.235C76.0928 290.117 76.2225 297.086 75.6283 303.968C75.0881 309.705 73.9969 315.431 74.2345 321.189C74.4722 326.948 76.2009 332.944 80.4253 336.866C82.5819 338.704 84.9904 340.225 87.5775 341.382C90.0682 342.769 92.7688 343.74 95.5725 344.256C96.9775 344.505 98.4205 344.435 99.7949 344.052C101.169 343.668 102.44 342.981 103.513 342.041C105.224 342.475 106.99 342.657 108.753 342.581Z",
    fill: "white"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M95.54 363.53V362.093L97.9277 360.073C97.9277 360.073 100.78 330.902 101.266 322.453C101.752 314.005 102.347 300.694 99.235 291.035C101.992 297.621 103.954 304.513 105.08 311.563C105.08 311.563 108.775 298.274 115.333 289.814C115.333 289.814 107.338 310.234 108.418 329.228C108.957 340.021 110.311 350.759 112.47 361.348L113.896 362.299L114.015 363.498L95.54 363.53Z",
    fill: "#407BFF"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M102.833 316.662C102.833 316.662 100.759 307.457 95.1729 302.898C95.1729 302.898 99.851 309.38 101.385 320.271C102.919 331.161 104.551 324.247 104.551 324.247L102.833 316.662Z",
    fill: "#407BFF"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M100.391 341.566C99.7258 339.307 98.2378 337.379 96.2207 336.164C96.2207 336.164 98.3815 338.238 99.3755 344.882C100.369 351.527 102.854 347.864 102.854 347.864L103.049 344.202L100.391 341.566Z",
    fill: "#407BFF"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M99.3971 344.872C98.3167 338.227 96.2423 336.153 96.2423 336.153C97.779 337.102 99.021 338.46 99.8293 340.075C100.478 332.998 101.083 325.943 101.288 322.453C101.288 321.762 101.363 321.027 101.396 320.292C99.8617 309.359 95.1943 302.92 95.1943 302.92C98.4355 305.567 100.499 309.791 101.677 312.859C101.774 305.664 101.353 297.539 99.2783 291.057C102.035 297.643 103.997 304.534 105.123 311.584C105.123 311.584 108.818 298.295 115.376 289.836C115.376 289.836 107.381 310.256 108.462 329.249C109 340.043 110.355 350.78 112.513 361.369L113.939 362.32L114.058 363.519H95.5401V362.082L97.9278 360.062C97.9278 360.062 98.6084 353.029 99.3971 344.872Z",
    fill: "black"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M426.996 347.205C422.508 347.044 418.102 345.95 414.06 343.992C410.018 342.034 406.429 339.255 403.521 335.832C400.612 332.409 398.449 328.418 397.169 324.113C395.889 319.808 395.52 315.284 396.086 310.828C396.896 304.475 399.554 298.533 401.434 292.461C404.989 280.879 406.123 267.817 414.269 258.861C416.781 256.102 419.842 253.898 423.255 252.39C426.668 250.881 430.358 250.102 434.089 250.102C437.821 250.102 441.511 250.881 444.924 252.39C448.337 253.898 451.397 256.102 453.909 258.861C459.192 264.641 461.699 272.485 462.79 280.242C463.881 287.999 463.709 295.875 464.432 303.687C465.037 310.169 466.269 316.652 466.01 323.134C465.75 329.616 463.784 336.401 459.02 340.842C456.569 342.924 453.833 344.645 450.895 345.952C448.081 347.518 445.03 348.613 441.863 349.193C440.276 349.475 438.646 349.396 437.093 348.962C435.541 348.528 434.106 347.751 432.895 346.687C430.965 347.146 428.978 347.321 426.996 347.205Z",
    fill: "#407BFF"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M426.996 347.205C422.508 347.044 418.102 345.95 414.06 343.992C410.018 342.034 406.429 339.255 403.521 335.832C400.612 332.409 398.449 328.418 397.169 324.113C395.889 319.808 395.52 315.284 396.086 310.828C396.896 304.475 399.554 298.533 401.434 292.461C404.989 280.879 406.123 267.817 414.269 258.861C416.781 256.102 419.842 253.898 423.255 252.39C426.668 250.881 430.358 250.102 434.089 250.102C437.821 250.102 441.511 250.881 444.924 252.39C448.337 253.898 451.397 256.102 453.909 258.861C459.192 264.641 461.699 272.485 462.79 280.242C463.881 287.999 463.709 295.875 464.432 303.687C465.037 310.169 466.269 316.652 466.01 323.134C465.75 329.616 463.784 336.401 459.02 340.842C456.569 342.924 453.833 344.645 450.895 345.952C448.081 347.518 445.03 348.613 441.863 349.193C440.276 349.475 438.646 349.396 437.093 348.962C435.541 348.528 434.106 347.751 432.895 346.687C430.965 347.146 428.978 347.321 426.996 347.205Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M441.885 370.845V369.235L439.194 366.944C439.194 366.944 435.953 333.981 435.424 324.484C434.894 314.988 434.214 299.916 437.714 289.015C434.604 296.457 432.395 304.244 431.135 312.211C431.135 312.211 426.964 297.215 419.563 287.654C419.563 287.654 428.585 310.709 427.375 332.155C426.758 344.332 425.227 356.445 422.794 368.392L421.184 369.472L421.044 370.812L441.885 370.845Z",
    fill: "#407BFF"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M433.673 317.948C433.673 317.948 436.007 307.555 442.317 302.401C442.317 302.401 437.033 309.672 435.305 322.021C433.576 334.37 431.718 326.494 431.718 326.494L433.673 317.948Z",
    fill: "#407BFF"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M436.482 346.06C437.231 343.504 438.912 341.321 441.193 339.945C441.193 339.945 438.784 342.29 437.638 349.787C436.493 357.285 433.695 353.115 433.695 353.115L433.49 348.988L436.482 346.06Z",
    fill: "#407BFF"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M437.563 349.787C438.708 342.289 441.117 339.945 441.117 339.945C439.374 341.01 437.966 342.546 437.055 344.375C436.331 336.39 435.651 328.417 435.424 324.484C435.424 323.696 435.337 322.864 435.294 322.01C437.023 309.672 442.306 302.401 442.306 302.401C438.633 305.394 436.31 310.158 435.002 313.626C434.894 305.502 435.37 296.34 437.714 289.015C434.604 296.457 432.395 304.244 431.135 312.211C431.135 312.211 426.964 297.215 419.563 287.654C419.563 287.654 428.585 310.709 427.375 332.155C426.758 344.332 425.227 356.445 422.794 368.392L421.184 369.472L421.044 370.812H441.885V369.202L439.194 366.912C439.194 366.912 438.438 359.003 437.563 349.787Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step-1.eb5f6321efd2c3508dd971aabb31e3f6.svg";
export { ForwardRef as ReactComponent };